import * as React from "react";
import { cx } from "@linaria/core";
import * as Icons from "react-feather";

/**
 * The underlying DOM element which is rendered by this component.
 */
const Root = "div";
interface Props extends React.ComponentPropsWithoutRef<typeof Root> {
  variant?: "info" | "warning" | "alert";
}
function Message(props: Props, ref: React.ForwardedRef<React.ElementRef<typeof Root>>) {
  const {
    variant,
    className,
    children,
    ...rest
  } = props;
  return <Root ref={ref} className={cx(className, "r1ssql2z", variant !== undefined && variantStyles[variant])} {...rest}>
      {variant && <div className={icon}>
          {{
        info: <Icons.ChevronsRight size={"1.5em"} />,
        warning: <Icons.AlertCircle size={"1.5em"} />,
        alert: <Icons.XOctagon size={"1.5em"} />
      }[variant]}
        </div>}
      <div className={"dhvu07f"}>
        {children}
      </div>
    </Root>;
}
export default React.forwardRef(Message);
const icon = "i1dz18jz";
const variantStyles = ({
  info: "i41wipx",
  warning: "wi7iy6",
  alert: "a1d5oxsn"
} as const);

require("./Message.linaria.module.css!=!../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./Message.tsx");